import { useMemo } from 'react';

import { usePatientVisits } from '../../react-query/usePatientVisits';

export const useVisits = (patientId: string | undefined) => {
  const { data: patientVisitsData, isLoading } = usePatientVisits({
    patientId: patientId || '',
  });

  const ddaiVisits = useMemo(
    () =>
      patientVisitsData?.visits.filter(
        (visit) => visit.source && visit.source === 'DDAI',
      ),
    [patientVisitsData],
  );

  const connectorVisits = useMemo(
    () => patientVisitsData?.visits.filter((visit) => visit.source !== 'DDAI'),
    [patientVisitsData],
  );
  const allVisits = patientVisitsData?.visits || [];

  return {
    allVisits,
    ddaiVisits,
    connectorVisits,
    isLoading,
  };
};
